import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { compose, graphql } from 'react-apollo';
import cx from 'classnames';
import PropTypes from 'prop-types';

import EditProfileInfo from '../../../components/siteadmin/EditProfileInfo/EditProfileInfo';
import Loader from '../../../components/Loader/Loader';

import showUserProfile from './showUserProfile.graphql';

import s from './EditProfile.css';
import NotFound from '../../notFound/NotFound';

class EditProfile extends React.Component {
    static propTypes = {
        profileId: PropTypes.number.isRequired,
        showUserProfile: PropTypes.object,
    };

    render() {
        const { userData, profileId } = this.props;
        let loading = userData?.loading;        

        if (loading) {
            return (
                <Loader type={"text"} />
            )
        }

        if (!loading && !userData?.showUserProfile?.firstName) {
            return (
                <div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
                    <NotFound />
                </div>
            )
        }

        return (
            <>
                <EditProfileInfo 
                    initialValues={userData?.showUserProfile} 
                    profileId={profileId} 
                    userId={userData?.showUserProfile?.userId} 
                />
            </>
        )
    }
}

export default compose(withStyles(s),
    graphql(showUserProfile, {
        name: 'userData',
        options: {
            ssr: true,
            fetchPolicy: 'network-only'
        }
    }),
)(EditProfile);
